export const COMMENT_REQUEST = 'COMMENT_REQUEST'
export const COMMENT_ERROR = 'COMMENT_ERROR'
export const COMMENT_GET_ALL = 'COMMENT_GET_ALL'
export const COMMENT_GET_ALL_SUCCESS = 'COMMENT_GET_ALL_SUCCESS'
export const COMMENT_CREATE = 'COMMENT_CREATE'
export const COMMENT_CREATE_SUCCESS = 'COMMENT_CREATE_SUCCESS'
